// frontend/modules/coa/index.ts
import { ModuleConfig } from '@/core/module';
import { coaRoutes } from './routes';
import { useCoaStore } from './stores/coa-store';

export const CoaModule: ModuleConfig = {
    name: 'coa',
    routes: coaRoutes,
    stores: {
        coa: useCoaStore
    },
    initialize: () => {
        console.log('COA module initialized');
    }
};